export default __webpack_public_path__ + "static/yawen-2c057379322e11b0013803c1df459e35.jpg";